import { ConversationParticipant } from '@centecomm/portal-service';
import React, { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { conversationsSelectors } from 'State';
import { ParticipantWasInvitedToConversation as ParticipantInvitedEvent } from 'Types/Conversations/Events';
import styles from '../conversations.module.css';

interface ParticipantWasInvitedToConversationProps {
    conversationId: number;
    event: ParticipantInvitedEvent;
}

function ParticipantWasInvitedToConversation({
    conversationId,
    event,
}: ParticipantWasInvitedToConversationProps): React.ReactElement<ParticipantWasInvitedToConversationProps> {
    useTranslation(['conversationsFeature']);
    const { invitedUserId, metadata } = event;

    const { userId: invitingUserId } = metadata;

    const invitedParticipant: ConversationParticipant | undefined = useSelector(
        conversationsSelectors.conversationParticipant(conversationId, invitedUserId),
    );

    const invitingParticipant: ConversationParticipant | undefined = useSelector(
        conversationsSelectors.conversationParticipant(conversationId, invitingUserId),
    );

    const resolvedI18nKey = useMemo(() => {
        if (invitedParticipant && invitingParticipant) {
            return 'conversationsFeature:events.participantWasInvitedToConversation.usernameInvitedUsername';
        }

        if (invitedParticipant && !invitingParticipant) {
            return 'conversationsFeature:events.participantWasInvitedToConversation.unknownInvitedUsername';
        }

        if (!invitedParticipant && invitingParticipant) {
            return 'conversationsFeature:events.participantWasInvitedToConversation.usernameInvitedUnknown';
        }

        return 'conversationsFeature:events.participantWasInvitedToConversation.unknownInvitedUnknown';
    }, [invitedParticipant, invitingParticipant]);

    return (
        <div className={styles.SystemItem}>
            <p>
                <Trans
                    i18nKey={resolvedI18nKey}
                    components={{
                        span: <span />,
                    }}
                    values={{
                        username: invitedParticipant?.userName,
                        invitingUsername: invitingParticipant?.userName,
                    }}
                />
            </p>
        </div>
    );
}

export default ParticipantWasInvitedToConversation;
